import React from "react";

function TitleMediumRoi() {
  return (
    <div className="title-line-medium-roi">
      <div className="title-roi-block1">Company / Individual name</div>
      <div className="title-roi-block1bis">Relationship</div>
      <div className="title-roi-block2">Filled</div>
      <div className="title-roi-block2bis">Revoked?</div>
      <div className="title-roi-block3">Actions</div>
    </div>
  );
}

export default TitleMediumRoi;
